/*
 * @Author: Niklaus
 * @Date: 2025-10-31 09:30:28
 * @LastEditTime: 2026-05-27 16:44:50
 * @LastEditors: Niklaus
 * @Description:
 */
import axios from "@/router/axios";
import apiUrls from "./apiUrl";
import qs from "qs";

const // 租赁费用收取明细台账
  getMachineDetail = (params) => {
    return axios({
      method: "get",
      data: params,
      url: "/api/park-statistics/statistics/queryReceiptByContractCode",
    });
  };

export default {
  getMachineDetail,
  // getStatFinanceLeaseExpenseDetail(params){
  //   return axios({
  //     method: 'post',
  //     params: params,
  //     url: apiUrls.getStatFinanceLeaseExpenseDetail
  //   })
  // },
  getStatFinanceLeaseExpenseDetail(params) {
    return axios({
      method: "post",
      data: params.body,
      url: apiUrls.getStatFinanceLeaseExpenseDetail,
      headers: params.headers,
    });
  },
  //面积测算
  getStatFinanceCalculateArea(params) {
    return axios({
      method: "post",
      data: params.body,
      url: apiUrls.getStatFinanceCalculateArea,
      headers: params.headers,
    });
  },
};
